module.exports = __webpack_public_path__ + "static/img/camera.44b9d1bb.png";